import { doc, getFirestore, serverTimestamp, setDoc } from 'firebase/firestore';
import { firebaseApp } from 'firebaseConfig';
import * as Sentry from '@sentry/react';

export const assignmentStatusDocumentId = (classId, kind, contentId) =>
  `${classId}_${kind}_${contentId}`;

export async function syncAssignmentStatusToFirestore({ classId, kind, contentId, active }) {
  if (!classId || !contentId || !kind) {
    return;
  }
  try {
    const db = getFirestore(firebaseApp);
    const ref = doc(db, 'assignment_status', assignmentStatusDocumentId(classId, kind, contentId));
    await setDoc(ref, { active: Boolean(active), modified: serverTimestamp() }, { merge: true });
  } catch (error) {
    Sentry.captureException(error);
  }
}
